"use strict";
/*
 * Created on 02 22 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ExportedOptimizationScenario_1 = require("../model/ExportedOptimizationScenario");

var ExportedOptimizationScenarioConverter_1 = require("./ExportedOptimizationScenarioConverter");
/**
 * @author Jaroslav Sevcik
 */


var ExportedOptimizationScenarioConverterImpl =
/*#__PURE__*/
function (_ExportedOptimization) {
  _inherits(ExportedOptimizationScenarioConverterImpl, _ExportedOptimization);

  function ExportedOptimizationScenarioConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ExportedOptimizationScenarioConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedOptimizationScenarioConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ExportedOptimizationScenarioConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ExportedOptimizationScenario_1.ExportedOptimizationScenario(ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.id.valueOf(conversions.documentToClassId(source)), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.computationStart.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.state.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.lastModified.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.nextAttempt.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.attemptCount.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.requestId.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.error.valueOfField(source), ExportedOptimizationScenario_1.ExportedOptimizationScenario.schema.processId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        computationStart: conversions.fromDate(source.computationStart),
        state: source.state,
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        lastModified: conversions.fromDate(source.lastModified),
        nextAttempt: conversions.fromDate(source.nextAttempt),
        attemptCount: source.attemptCount,
        requestId: source.requestId,
        error: source.error,
        processId: source.processId
      });
      return result;
    }
  }]);

  return ExportedOptimizationScenarioConverterImpl;
}(ExportedOptimizationScenarioConverter_1.ExportedOptimizationScenarioConverter);

ExportedOptimizationScenarioConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ExportedOptimizationScenarioConverterImpl);
exports.ExportedOptimizationScenarioConverterImpl = ExportedOptimizationScenarioConverterImpl;